import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { createGlobalStyle } from 'styled-components';

const HeaderStyles = createGlobalStyle`
    .result-input .form-header {
        font-size: ${props => props.size}px;
    }
    @media only screen and (max-width: 768px) {
        .result-input .form-header {
            font-size: ${props => props.mobileSize}px;
        }
    }
`;

class Header extends Component {

    state = {
        size: this.props.initialValues.size || 20,
        mobileSize: this.props.initialValues.mobileSize || 16,
        name: this.props.initialValues.label || 'Form name',
        textAlign: this.props.initialValues.align || 'left'
    };

    updateInputPropsInStore = () => {
        const inputProps = {
            type: this.props.initialValues.type,
            label: this.state.name,
            size: this.state.size,
            mobileSize: this.state.mobileSize,
            align: this.state.textAlign,
        };
        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    };

    componentDidUpdate() {
        this.updateInputPropsInStore();
    };

    setSize = (e, name) => {
        if (e.target.value > 64) {
            e.target.value = 64
        }

        if (e.target.value < 0) {
            e.target.value = 1
        }

        this.setState({ [name]: e.target.value })
    };

    setName = (e) => {
        this.setState({ name: e.target.value })
    };

    setTextAlign = (e) => {
        this.setState({ textAlign: e.target.value})
    };

    render() {
        const { textColor, isResultInput } = this.props;
        const { textAlign, size, mobileSize, name } = this.state;
        return (
            <>
                <div className="result-input">
                    <h1
                        className="form-header inner-margin"
                        style={{ color: textColor, textAlign: textAlign }}
                    >{ name }</h1>
                    <HeaderStyles size={size} mobileSize={mobileSize}/>
                </div>
                {
                    !isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">
                            <label>
                                <input onChange={(e) => this.setSize(e, 'size')} type="number" value={size}/>
                                desktop size(px)
                            </label>
                            <label>
                                <input onChange={(e) => this.setSize(e, 'mobileSize')} type="number" value={mobileSize}/>
                                mobile size(px)
                            </label>
                            <label>
                                <input value={name} onChange={this.setName} type="text"/>
                                name
                            </label>
                            <label>
                                <select value={textAlign} onChange={this.setTextAlign}>
                                    <option>left</option>
                                    <option>center</option>
                                    <option>right</option>
                                </select>
                                Text alignment
                            </label>

                        </div>
                    </AppCollapsible>
                }
            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(Header);